// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"CoachTabs__materialize-textarea___3u_fD","modal-2463794813":"CoachTabs__modal-2463794813___1Qu_t","container":"CoachTabs__container___2FTIB","activeClass":"CoachTabs__activeClass___16ooB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CoachTabs/CoachTabs.scss
// module id = 1479
// module chunks = 0